module.exports = __webpack_public_path__ + "img/logo.2700e903.png";